import { isAirror } from '@air/errors';

import { is4xxError, isAbortError } from './uploadErrors';

export const isRetryableUploadTransferError = (error: unknown): boolean => {
  if (isAbortError(error)) {
    return false;
  }

  if (is4xxError(error)) {
    return false;
  }

  if (isAirror(error)) {
    return false;
  }

  return true;
};
